var _a;
import { __assign } from "tslib";
import { combineActions, handleActions } from 'redux-actions';
import { initialize, initializeSuccess, initializeTierTagsSuccess, deinitialize, submitDeviation, deviationSaveError, } from './actions';
var handler = handleActions((_a = {},
    _a[combineActions(submitDeviation).toString()] = function (state, action) { return (__assign(__assign({}, state), { requestStatus: 'fetching', errorMessage: undefined })); },
    _a[deviationSaveError.toString()] = function (state, action) { return (__assign(__assign({}, state), { requestStatus: 'error', errorMessage: action.payload.message })); },
    _a[initialize.toString()] = function (state, action) { return (__assign(__assign({}, state), { response: undefined, requestStatus: 'initializing' })); },
    _a[initializeSuccess.toString()] = function (state, action) { return (__assign(__assign({}, state), { response: __assign({}, action.payload), requestStatus: 'idle' })); },
    _a[deinitialize.toString()] = function (state, action) { return (__assign(__assign({}, state), { response: undefined, requestStatus: 'uninitialized' })); },
    _a[initializeTierTagsSuccess.toString()] = function (state, action) {
        var _a;
        return (__assign(__assign({}, state), { tagsByTierId: __assign(__assign({}, state.tagsByTierId), (_a = {}, _a[action.payload.tierId] = action.payload.tags, _a)) }));
    },
    _a), {
    requestStatus: 'uninitialized',
});
export default handler;
//# sourceMappingURL=reducer.js.map